import { Severity, addBreadcrumb, captureException } from '@sentry/browser';
import React from 'react';

export class ErrorReporter extends React.Component<{boundary: string}> {

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error);
    addBreadcrumb({
      message: error.message,
      data: errorInfo,
      category: `lifecycle: ${this.props.boundary}`,
      level: Severity.Error,
      type: 'error',
    });
    captureException(error);
  }

  render() {
    return this.props.children;
  }
}
